'use client';

import React from 'react';
import Image from 'next/image';

const Grade = ({ className = '', title, subtitle, items }) => {
  return (
    <div className={className}>
      <div className='bg-lime-400 rounded-[30px] h-[92px] px-[22px] flex items-center mb-[22px]'>
        <h3 className='text-2xl font-oswald font-semibold text-dark-navy uppercase leading-[39px] max-w-[300px]'>
          <span className='font-bold'>{title}</span> {subtitle ? '- ' : ''}
          {subtitle && <span className='font-normal'>{subtitle}</span>}
        </h3>
      </div>

      <div className='space-y-4'>
        {items.map((item, i) => (
          <div className='flex items-center space-x-3' key={i}>
            <Image
              src='./images/img_check.svg'
              alt='Check'
              width={18}
              height={18}
              className='mt-1'
            />
            <p className='text-lg font-montserrat text-white leading-[1.5]'>
              {item}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Grade;
